/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { FormTranslationKeys } from '@common/entities';
import styled from '@emotion/styled';

import { useApplicationSettings } from 'hooks/useApplicationSettings';

interface Option {
  id?: string | number;
  label: string;
  value: string | number | boolean;
  testKey?: string;
  target?: any;
}

interface ValidationRules {
  required?: boolean;
}

interface RadioButtonProps {
  label: string;
  options: Option[];
  name: string;
  required?: boolean;
  isDisabled?: boolean;
  defaultValue?: string;
  validation?: ValidationRules;
  direction?: 'row' | 'column';
  hideErrorMessage?: boolean;
  onChange?: (value: string) => void;
  [key: string]: any;
}

const RouteRadioButton: React.FC<RadioButtonProps> = (props) => {
  const { id, label, options, setTargetId, setTargetType, setTargetName, setTargetProperties } =
    props;
  const { t } = useTranslation('viewer');

  const { updateSettings } = useApplicationSettings();
  const fieldId = id as string | undefined;
  const translatedLabel = fieldId ? t(FormTranslationKeys.field.label(fieldId), label) : label;

  return (
    <Box>
      <Label>{translatedLabel}</Label>
      <RadioGroup
        my={1}
        onChange={(value) => {
          const target = JSON.parse(value);
          setTargetId(target.id);
          setTargetType(target.type);
          setTargetName(target.name);
          setTargetProperties(target.properties ?? []);
          updateSettings(target.settings ?? {});
        }}
      >
        <Stack direction="column">
          {options.map((item: Option, index: number) => (
            <Radio
              size="sm"
              borderColor="lightgrey"
              data-testid={`route-radio-option-${index}`}
              key={`radio-button-${index}-${item.value}`}
              value={JSON.stringify({ ...item.target, index })}
            >
              <Text fontSize="sm">
                {' '}
                {fieldId
                  ? t(FormTranslationKeys.field.optionLabel(fieldId, item.id ?? index), item.label)
                  : item.label}
              </Text>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
};

const Label = styled.div`
  padding: 2px 0;
  font-size: 15px;
  font-weight: 500;
`;
export default RouteRadioButton;
